import buildProviderParams, { providerParamsReset } from './cta-params';
import getDeviceType from '../../util/deviceType';

// UA doesn't change during the page, so resolve the device bucket once (HOME-9865).
const DEVICE_TYPE = getDeviceType();

const
    REFERRAL_CTA_SELECTOR = '[data-ga="referral-cta"]',
    REFERRAL_CALL_SELECTOR = '[data-ga="referral-call"]',
    SYSTEM_FINDER_BANNER_CTA = document.querySelectorAll('.finder-cta-btn'),
    QUIZ_CTA_VERSION1 = document.querySelectorAll('.section.version1 a.ref-btn'),
    QUIZ_CTA_VERSION2 = document.querySelectorAll('.section.version2 a.ref-btn'),
    BANNER_CTA = document.querySelectorAll('.banner-cta a'),
    PAGETYPE_FIELD = document.getElementById('pagetype'),
    PRODUCT_BRAND = document.getElementById('product_brand_interest'),
    INTERNAL_LINKS_SELECTOR = '[data-link-type="internal"]',
    EXTERNAL_LINKS_SELECTOR = '[data-link-type="external"]',
    ON_PAGE_LINKS_SELECTOR = '[data-link-type="on-page"]',
    SEARCH_FORM = document.querySelector('.search-form');

function triggerEventTracking() {
    // Get context of page
    const pageTypeValue = PAGETYPE_FIELD ? PAGETYPE_FIELD.value : 'generic',
        productBrand = PRODUCT_BRAND ? PRODUCT_BRAND.value : '';

    // Get Element Placement of CTA
    function elementPlacement($element) {
        return $element.dataset.elementplacement || null;
    }

    // Get CTA URL of CTA
    function ctaUrl($element) {
        return $element.href || null
    }

    // Get Index of CTA
    function providerIndex($element) {
        return $element.dataset.order || 'single'
    }

    // Get Destination Type of CTA
    function destinationType($element)
    {
        return $element.dataset.destination || 'generic'
    }

    // Get Element Clicked of CTA
    function elementClicked($element)
    {
        return $element.dataset.elementclicked || ''
    }

    // Get Element Clicked of CTA
    function linkText($element)
    {
        if ($element.innerText !== '') {
            return $element.innerText;
        } else if ($element.innerHTML.includes('img')) {
            return 'image';
        } else {
            return '';
        }
    }

    function getDirection($element)
    {
        return $element.dataset.direction || '';
    }

    // Check if active promotion
    function checkActivePromotion()
    {
        return document.body.classList.contains('promotion-active') || 'false'
    }

    function buildDatalayerParams($element)
    {
        // Shared with provider_impression so both events report identical params.
        return buildProviderParams($element);
    }

    function pushIsolatedCTAEvent(eventData) {
        window.dataLayer.push(eventData);

        // GTM Data Layer Variables are "last value wins" and persist across
        // pushes, so clear the CTA-specific keys once the event has fired.
        // Without this, a later unrelated event (site_search, on_page_link_click,
        // internal/external link clicks, etc.) inherits this CTA's
        // serviceProvider / partner / position / providerCID / etc. (HOME-9595).
        // The key list lives in cta-params.js next to the builder, so the
        // provider_impression producer cleans up exactly the same set.
        setTimeout(() => {
            window.dataLayer.push(providerParamsReset());
        }, 0);
    }

    function triggerClickOutAction(elementTarget)
    {
        const defaultData = {
            'event': 'cta_click_out',
            'elementClicked': 'cta button',
            'destinationType': destinationType(elementTarget),
        };
        const dataLayerData = Object.assign(defaultData, buildDatalayerParams(elementTarget));
        pushIsolatedCTAEvent(dataLayerData);

        console.log(dataLayerData);

    }

    function triggerCallClickOutAction(elementTarget)
    {
        const defaultData = {
            'event': 'cta_call_click',
            'elementClicked': 'phone link',
            'destinationType': 'provider',
        };
        const dataLayerData = Object.assign(defaultData, buildDatalayerParams(elementTarget));
        pushIsolatedCTAEvent(dataLayerData);

        console.log(dataLayerData);

    }

    function triggerInternalExternalClick(elementTarget, linkType)
    {

        const eventAction = linkType === 'internal' ? 'internal_link_click' : 'external_link_click';
        const defaultData = {
            'event': eventAction,
            'elementPlacement': elementPlacement(elementTarget),
            'elementClicked': elementClicked(elementTarget),
            'position': providerIndex(elementTarget),
            'href': ctaUrl(elementTarget),
            'linkText': linkText(elementTarget),
        };
        window.dataLayer.push(defaultData);
        console.log(defaultData);
    }

    function triggerOnPageClick(elementTarget)
    {

        const defaultData = {
            'event': 'on_page_link_click',
            'elementPlacement': elementPlacement(elementTarget),
            'elementClicked': elementClicked(elementTarget),
            'pageUrl': window.location.href,
            'position': providerIndex(elementTarget),
            'linkText': linkText(elementTarget),
            'direction': getDirection(elementTarget),
        };
        window.dataLayer.push(defaultData);

        console.log(defaultData);
    }

    // Referral Call click
    document.addEventListener('click', function (e) {
        const ctaClickout = e.target.closest(REFERRAL_CTA_SELECTOR);
        const callClickout = e.target.closest(REFERRAL_CALL_SELECTOR);
        const internalClickout = e.target.closest(INTERNAL_LINKS_SELECTOR);
        const externalClickout = e.target.closest(EXTERNAL_LINKS_SELECTOR);
        const onPageClickout = e.target.closest(ON_PAGE_LINKS_SELECTOR);

        if (ctaClickout) {
            if (ctaClickout.classList.contains('quiz-cta-btn') === false) {
                triggerClickOutAction(ctaClickout);
            }
        }

        if (callClickout) {
            triggerCallClickOutAction(callClickout);
        }

        if (internalClickout) {
            triggerInternalExternalClick(internalClickout, 'internal');
        }

        if (externalClickout) {
            triggerInternalExternalClick(externalClickout, 'external');
        }

        if (onPageClickout) {
            triggerOnPageClick(onPageClickout);
        }
    });

    // System Finder footer cta
    if (SYSTEM_FINDER_BANNER_CTA) {
        SYSTEM_FINDER_BANNER_CTA.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const elementTarget = e.currentTarget;
                window.dataLayer.push({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': elementClicked(elementTarget),
                    'href': ctaUrl(elementTarget),
                });

                console.log({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': elementClicked(elementTarget),
                    'pageType': pageTypeValue,
                    'href': ctaUrl(elementTarget),
                });
            });
        });
    }

    // Banner cta box within content
    if (BANNER_CTA) {
        BANNER_CTA.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const elementTarget = e.currentTarget;
                window.dataLayer.push({
                    'event': 'cta_click_out',
                    'elementPlacement': 'tip box banner cta',
                    'elementClicked': 'text link',
                    'href': ctaUrl(elementTarget),
                    'serviceProvider': productBrand || '',
                    'activePromotion': checkActivePromotion(),
                    'position': 'single',
                    'linkText': linkText(elementTarget),
                    'deviceType': DEVICE_TYPE,
                });

                console.log({
                    'event': 'cta_click_out',
                    'elementPlacement': 'tip box banner cta',
                    'elementClicked': 'text link',
                    'href': ctaUrl(elementTarget),
                    'serviceProvider': productBrand || '',
                    'activePromotion': checkActivePromotion(),
                    'position': 'single',
                    'linkText': linkText(elementTarget),
                    'deviceType': DEVICE_TYPE,
                });
            });
        });
    }

    // Quiz CTA version 1
    if (QUIZ_CTA_VERSION1) {
        QUIZ_CTA_VERSION1.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const elementTarget = e.currentTarget;
                elementTarget.dataset.productname = 'quiz';

                // New push for click out
                const defaultData = {
                    'event': 'cta_click_out',
                    'elementClicked': 'quiz cta version 1',
                    'destinationType': 'internal',
                };
                const dataLayerData = Object.assign(defaultData, buildDatalayerParams(elementTarget));
                pushIsolatedCTAEvent(dataLayerData);

                console.log(dataLayerData);

                // New push for lead form entry
                window.dataLayer.push({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': 'Quiz CTA Version 1',
                    'href': ctaUrl(elementTarget),
                });

                console.log({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': 'Quiz CTA Version 1',
                    'href': ctaUrl(elementTarget),
                });
            });
        });
    }

    // Quiz CTA version 2
    if (QUIZ_CTA_VERSION2) {
        QUIZ_CTA_VERSION2.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const elementTarget = e.currentTarget;
                elementTarget.dataset.productname = 'quiz';

                // New push for click out
                const defaultData = {
                    'event': 'cta_click_out',
                    'elementClicked': 'quiz cta version 2',
                    'destinationType': 'internal',
                };
                const dataLayerData = Object.assign(defaultData, buildDatalayerParams(elementTarget));
                pushIsolatedCTAEvent(dataLayerData);

                console.log(dataLayerData);

                // New push for lead form entry
                window.dataLayer.push({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': 'Quiz CTA Version 2',
                    'href': ctaUrl(elementTarget),
                });

                console.log({
                    'event': 'cta_lead_form_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': 'Quiz CTA Version 2',
                    'href': ctaUrl(elementTarget),
                });
            });
        });
    }

    // Search Form
    if (SEARCH_FORM) {
        SEARCH_FORM.addEventListener('submit', () => {
            const defaultData = {
                'event': 'site_search',
                'searchTerm': document.querySelector('.search-field').value || '',
                'elementClicked': 'search form',
            };
            window.dataLayer.push(defaultData);

            console.log(defaultData);
        });
    }
}

export default function init() {
    triggerEventTracking();
}
